/**
 * projectName 租户间稿库
 * createTime 2019-05-20
 * name zhang.yingyu
 */
"use strict";
angular.module("tenantManuscriptModule", [
    'tenantManuscriptLeftModule', //特色资源左侧导航
    'tenantManuscriptRouterModule', //特色资源路由
    'postTenantModule',//发出
    'receiveTenantModule',//收到
    'tenantManuscriptPreviewModule',//租户间稿库详情
]);
